"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageProvider = void 0;
const _reduxjs_1 = require("../../utils/@reduxjs");
const slice_1 = require("./slice");
const useStorageProvider = () => {
    (0, _reduxjs_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
};
exports.useStorageProvider = useStorageProvider;
//# sourceMappingURL=useStorageProvider.js.map